import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, mergeMap, Observable, of, switchMap, tap } from 'rxjs';
import { SpanModel } from '../../../model/span.model';
import { TowerModel } from '../../../model/tower.model';
import { HttpClient } from '@angular/common/http';
import { PROJECTS_API } from '../../../config/general.config';
import { LineModel } from '../../../model/line.model';
import { OrderType } from '../../../config/order.config';
import { LinePdfModel } from "../../settings/model/import-pdf.model";
import { AttachmentService } from 'src/app/services/attachment.service';
import { AttachmentEntity } from 'src/app/config/dbstorage.config';
import { OfflineService } from 'src/app/services/offline.service';
import { Attachment } from 'src/app/model/file.model';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private dataApi(projectUuid: string): string {
    return `${PROJECTS_API}/${projectUuid}/data`;
  }

  constructor(
    private _http: HttpClient,
    private attachmentService: AttachmentService,
    private offlineService: OfflineService
  ) { }

  getSpanData(projectId: string): Observable<SpanModel[]> {
    return this._http.get<SpanModel[]>(this.dataApi(projectId) + '/spans').pipe(
      tap((result) => console.log(result.map(x => (`${x.startTower.externalId} - ${x.endTower.externalId}`))))
    )
  }

  getTowerData(projectId: string): Observable<TowerModel[]> {
    return this._http.get<TowerModel[]>(this.dataApi(projectId) + '/towers')
  }

  getLinesData(projectId: string): Observable<LineModel[]> {
    return this._http.get<LineModel[]>(this.dataApi(projectId) + '/lines')
  }

  getDataFilters(projectId: string, dataType: OrderType): Observable<string[]> {
    return this._http.get<string[]>(this.dataApi(projectId) + '/headers?dataType=' + dataType);
  }

  getPdfFiles(projectId: string): Observable<LinePdfModel[]> {
    return this._http.get<LinePdfModel[]>(this.dataApi(projectId) + '/lines/pdf');
  }

  cacheLinePdfs(projectId: string): Observable<(Attachment[] | null)[]> {
    return this.getPdfFiles(projectId).pipe(
      switchMap(lines => {
        const requests$ = lines
        .map(line =>
            this.offlineService.attachmentExists(line.linePdf.id)
            .pipe(
              switchMap(exists => {
                if(exists) {
                  return of(null);
                }
                return this.attachmentService.download(line.linePdf.id).pipe(
                  map((file: Blob) => {
                    return {
                      attachmentId: line.linePdf.id,
                      taskId: "",
                      thumbnail: "",
                      payload: [
                        ["files", file],
                        ["type", "LINE_PDF"]
                      ]
                    } as AttachmentEntity
                  }),
                  mergeMap(attachment => {
                    return this.offlineService.saveAttachmentEntity(attachment, 'LINE_PDF')
                  }),
                  catchError(() => of(null))
                )
              })
            )
        )
        return requests$.length ? forkJoin(requests$) : of([]);
      })
    );
  }
}
